import React, { useEffect } from 'react';
import { Heading } from '../components/Heading/Heading';
import { Container } from '../components/Container/Container';
import { Text } from '../components/Text/Text';

const OnlineCoursePage: React.FC = () => {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div>
      <Container contentClassName="py-16 text-center flex-col" hasPadding>
        <Heading intent="h4" className="text-center">
          Online Course
        </Heading>
        <Text>Coming soon...</Text>
      </Container>
    </div>
  );
};

export default OnlineCoursePage;
